import Vue from 'vue'
import Amplify, { Auth } from 'aws-amplify'
import App from './App.vue'
import router from './router'
import store from './store/'
import './bootstrap/'
import './registerServiceWorker'
import { renderError } from './utils/error'
import 'regenerator-runtime/runtime'

Vue.config.productionTip = false

/**
 * 前処理 - 認証チェック
 */
async function checkAuth() {
  // まずThemeから取得したidを用いてCognitoの設定を行う
  // 先にconfigureしておかないと、ログイン済みだとしてもAuthで判定ができない

  await store.dispatch('theme/fetch')

  Amplify.configure({
    userPoolId: store.state.theme.cognito.userPoolId,
    userPoolWebClientId: store.state.theme.cognito.clientId
  })

  const user = await Auth.currentUserInfo()

  // ログイン済みであれば、ユーザー情報をセットする
  // これにより、画面リロードで認証判定がリセットされることを防ぐ
  if (user) {
    store.commit('auth/SET_USER', user.attributes)
  }
}

/**
 * Vue起動
 */
function createApp() {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

checkAuth().then(createApp).catch(err => {
  createApp()

  // システムエラー画面へ遷移する
  router.onReady(() => renderError(err))
})
